// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ClaimHeaderDetails from './claim-header-details';
import ClaimSearchDetails from './claim-search-details';
import ClaimSearchResult from '@deere/cps-it.warranty-model-factory/lib/claim-search-result';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import ListViewShowMore from '../../../shared/components/list-view-show-more';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import SmartFormLink from '../../../shared/components/smart-form-link/smart-form-link';
import {buildClaimRoutes} from '../../../shared/services/build-claim-route';
import {formatClaimNumber} from '../../../shared/services/format-claim-number';

const ClaimSearchList = (props, context) =>
    <div>
        {props.claims.length || props.busyCounter ?
            <ul>
                <ListViewShowMore
                    initialShowItems={50}
                    perMoreMultiplier={1.25}
                    showAllOption={true}
                    showPerMore={50}
                    totalItems={props.claims.length}
                >
                    {props.claims.map((claim, index) =>
                        <li
                            className='claim-search-list'
                            key={index}
                        >
                            <div className='claim-search-information-container'>
                                <header>
                                    <div className='claim-link'>
                                        {
                                        claim.claimType.key === 'ZPNV' ? <SmartFormLink
                                            displayText={claim.claimNumber}
                                            formName='CLAIM'
                                            objectId={claim.claimNumber}
                                            translate={false}
                                                                         /> : <Link to={buildClaimRoutes(claim.claimType.key, claim.subClaimType.key, claim.claimNumber)}>
                                                                             {formatClaimNumber(claim.claimNumber)}</Link>
                                        }
                                        {` ${claim.claimType.value} ${claim.subClaimType.value ? ` - ${claim.subClaimType.value}` : ''}`}
                                    </div>
                                    <ClaimHeaderDetails
                                        claim={claim}
                                        security={context.security}
                                    />
                                </header>
                                <ClaimSearchDetails
                                    actions={props.actions}
                                    claim={claim}
                                    isEditable={props.isEditable}
                                    key={index}
                                />
                            </div>
                        </li>
                    )}
                </ListViewShowMore>
            </ul> :
            <FormattedMessage id='NO_CLAIMS'/>
        }
    </div>;

ClaimSearchList.displayName = 'ClaimSearchList';
ClaimSearchList.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    claims: PropTypes.arrayOf(PropTypes.instanceOf(ClaimSearchResult)).isRequired,
    isEditable: PropTypes.bool.isRequired
};
ClaimSearchList.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired
};

export default ClaimSearchList;



// WEBPACK FOOTER //
// ./src/claim/claim-search/components/claim-search-list.js